import { ref } from "vue";

// state
export const bannerDom = ref(null);
export const introductionDom = ref(null);
export const successDom = ref(null);
export const footerDom = ref(null);
